module.exports = __webpack_public_path__ + "assets/img/wgcl1.8aa943d5.png";